import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-session-audit-modal',
  templateUrl: './session-audit-modal.component.html',
  styleUrls: ['./session-audit-modal.component.scss']
})
export class SessionAuditModalComponent {
  @Input() isSessionAuditModalShow!: boolean;
  @Input() sessionId: string = '';
  @Output() showSessionAuditModal = new EventEmitter<boolean>();
  ngOnInit(): void {
  }
  closeSessionAuditModal = () => {
    this.isSessionAuditModalShow = false;
    this.showSessionAuditModal.emit(false);
  }
}
